export default "assets/images/background-ef8f484e.jpg";